import React, { Component } from 'react'
import Link from '../Link';
import { TweenMax, Power2 } from 'gsap'
import './style.scss';
export default class CatProduct extends Component {

    onMouseOverHandle(product) {
        //console.log(this.img)
        TweenMax.to(this.img, 0.4, { scale:1.1 });
        //TweenMax.to(this.imgContainer, 0.4, { clipPath:'inset(10px)', webKitClipPath:'inset(10px)',  ease: Power2.easeInOut });
  
    }

    onMouseLeaveHandle() {
        TweenMax.to(this.img, 0.4, { scale:1 });
        //TweenMax.to(this.imgContainer, 0.4, { clipPath:'inset(0px)', webKitClipPath:'inset(0px)',  ease: Power2.easeInOut });
    }


  render() {
    
    const product = this.props.product;
    return (
        <div key={product.node.id} className="col-md-6">
            <Link ref={(e) => this.container = e} onMouseLeave={() => this.onMouseLeaveHandle()} onMouseEnter={() => this.onMouseOverHandle()} to={'/case-study/'+product.node.slug} className="cs-product">
                <div className="cs-product--product-image" ref={(e) => this.imgContainer = e}>
                    { product.node.featured_media ? 
                    <img class="cs-project-img" key={product.node.id}  ref={(e) => this.img = e} src={product.node.featured_media.source_url}  /> : null }
                </div>
                <div  ref={(e) => this.detailsContainer = e} className="cs-product--product-details">
                    <div className="project-detail-title home-recent--project--details--name"><span className="bg-block--container"></span><span  dangerouslySetInnerHTML={{__html: product.node.title}}></span></div>
                    <div className="project-details.type home-recent--project--details--type"><span className="bg-block--container"></span>{this.props.cat.name}</div>
                    {/* <div>MORE DETAILS</div> */}
                </div>
            </Link>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CatProduct/index.js